import React, { useEffect, useState } from 'react';
import useAsync from '../hooks/useAsync';
import { useNavigate } from 'react-router-dom';
import SubscriptionServices from '../services/SubcriptionServices';
import UserUpdate from './Update Model/UpdateUser';
import ViewUsersubcription from './View Model/ViewUsersubcription';
import DeleteButton from './Button/DeleteButton';
import Modal from 'react-modal';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import { FaRegEye } from "react-icons/fa";
import { Tooltip } from 'react-tooltip'
import Swal from 'sweetalert2';
Modal.setAppElement('#root');
function SubcriptionUserManager() {
  const { data, error, isLoading, run } = useAsync(SubscriptionServices.getSubcriptionUsers);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userTypeFilter, setUserTypeFilter] = useState('');
  const [planFilter, setPlanFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState(data?.data || []);

  // Add this useEffect to update filtered data when data changes
  useEffect(() => {
    if (data?.data) {
      setFilteredData(data.data);
    }
  }, [data]);

  const handleViewDetails = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const handleEditDetails = (help) => {
    setSelectedEdit(help);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (help) => {
    setSelectedEdit(help);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  const usersPerPage = 20;
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;

const filteredUsers = (data?.data || []).filter((subscription) => {
  const user = subscription?.userId || {};
  const seller = subscription?.sellerDetails || {};

  const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`.toLowerCase();
  const email = user?.email?.toLowerCase() || '';
  const mobileNo = user?.mobileNo?.toString() || '';
  const sellerName = `${seller?.firstName || ''} ${seller?.lastName || ''}`.toLowerCase();

  const matchesSearch =
    fullName.includes(searchQuery.toLowerCase().trim()) ||
    email.includes(searchQuery.toLowerCase()) ||
    mobileNo.includes(searchQuery) ||
    sellerName.includes(searchQuery.toLowerCase().trim());

  const matchesPlan =
    planFilter === 'hasPlan'
      ? !!subscription?.membershipId?.name
      : planFilter === 'noPlan'
        ? !subscription?.membershipId?.name
        : true;

  return matchesSearch && matchesPlan;
});

  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const generateExcel = () => {
    const filteredData = filteredUsers?.map((subscription, index) => {
      const user = subscription.userId || {};
      const seller = subscription?.sellerDetails || {};
      return {
        SNo: index + 1,
        Name: `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 'N/A',
        MobileNo: user?.mobileNo ? String(user.mobileNo) : 'N/A',
        PlanName: subscription?.membershipId?.name || 'N/A',
        PlanPrice: subscription?.membershipId?.price || 'N/A',
        SellerName: `${seller?.firstName || "N/A"} ${seller?.lastName || ""}`,
        // SellerUserName: `${seller?.firstName || "N/A"} ${seller?.lastName || ""}`,
        EarningType: seller?.earningType || "N/A",
        KYCStatus: seller?.isKycVerified ? "Verified" : "Not Verified",
        PaymentMode: subscription?.paymentMode || 'N/A',
        PaymentStatus: subscription?.payment_status || 'N/A',
        SubscriptionStatus: subscription?.status || 'N/A',
        UpdatedDate: subscription?.updatedAt
          ? formatDate(subscription.updatedAt)
          : 'N/A',
        EndDate: subscription?.endDate
          ? formatDate(subscription.endDate)
          : 'N/A',

      };
    });
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Users');
    XLSX.writeFile(wb, 'user_subscription_data.xlsx');
  };
  const handleSubscriptionStatusChange = async (status, user) => {
    try {
      const body = {
        status: "Active",
        payment_status: status
      };
      const res = await SubscriptionServices.userMembershipUpdateStatus(
        user._id,
        body
      );

      if (res.data.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: `Service request ${status} successfully`,
          timer: 1500,
          showConfirmButton: false
        });

        run()
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong"
        });

      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Failed to update status"
      });

      console.log(error);

    }
  };
  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const handleUserTypeChange = (e) => {
    setUserTypeFilter(e.target.value);
  };

  const handlePlanChange = (e) => {
    setPlanFilter(e.target.value);
  };
  const normalizeStatus = (status) => {
    if (!status) return "Pending";
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  };
  return (
    <div className="right_col" role="main">
      <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">
        <div className="my-auto">
          <h5 className="page-title fs-21 mb-1">
          Active Customer
            <span className="badge bg-warning ms-2">
              Total: {filteredUsers.length}
            </span>
          </h5>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="javascript:void(0);">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                User List
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center">
          <div className="pe-1 mb-xl-0">
            <div className="sub-title-box-right d-flex" style={{ gap: 20 }}>
              <button className="excel-btn" onClick={generateExcel}>
                <img src="img/excel.svg" alt="Download Excel" />
                Download
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container-box px-0 user-manager">
        <div className="Tablesearch_design">
          <div className="row">
            <div className="col-sm-6  col-md-6 ">
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <div className=' w-100'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search by Name, Mobile and Email id"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className='form-control'
                  />
                </div>
                <div>
                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>
            {/* <div className="col-sm-3 col-6">
              <div className="input-field">
                <select className="form-select selectcustum" value={userTypeFilter} onChange={handleUserTypeChange}>
                  <option value="">User Type</option>
                  <option value="Android">Android</option>
                  <option value="iOS">iOS</option>
                </select>
              </div>
            </div> */}
            <div className="col-sm-6 col-md-6">
              <div className="input-field">
                <select className="form-select selectcustum" value={planFilter} onChange={handlePlanChange}>
                  <option value="">Filter</option>
                  <option value="hasPlan">Plan Holder</option>
                  <option value="noPlan">No Plan</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="row mb-3">
          <div className="col-md-12">
            <div className="card summary-card">
              <div className="card-body">
                <h6 className="card-title mb-3 fw-semibold">Summary</h6>

                <div className="row g-3">
                  <div className="col-md-3 col-sm-6">
                    <div className="summary-box">
                      <span className="summary-label">Total Active Subscriptions</span>
                      <span className="summary-value">{filteredUsers.length}</span>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6">
                    <div className="summary-box">
                      <span className="summary-label">Total Completed Bookings</span>
                      <span className="summary-value">
                        {filteredUsers.reduce(
                          (total, sub) => total + (sub.completedBookingsCount || 0),
                          0
                        )}
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div> */}

        <div className="container-box-inner table-reponsive-tabe">
          <table id="example" className="table table-striped" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>#</th>
                <th> NAME</th>
                <th>MOBILE NO.</th>
                <th>SERVICE NAME</th>
                <th>CATEGORY NAME</th>
                <th>ACTIVE SERVICE DATE</th>
                <th>END SERVICE DATE</th>
                <th>REFER BY</th>
                <th>SELLER DETAIL</th>
                <th>PAYMENT MODE </th>
                <th>AMOUNT</th>
                <th>PAYMENT STATUS</th>
                <th>STATUS</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {currentUsers?.map((subscription, index) => {
                const user = subscription.userId || {};
                return (
                  <tr key={subscription?._id || index}>
                    <td>{index + 1 + indexOfFirstUser}</td>
                    <td>
                      {`${user?.firstName || ""} ${user?.lastName || ""}`.trim() || "N/A"}
                    </td>
                    <td>{user?.mobileNo || "N/A"}</td>
                    <td>{subscription?.membershipId?.name || "N/A"}</td>
                    <td>{subscription?.membershipId?.categoryId?.name || "N/A"}</td>
                    <td>{formatDate(subscription?.updatedAt || "N/A")}</td>
                    <td>{formatDate(subscription?.endDate || "N/A")}</td>
                    <td>
                      {subscription?.referDetails ? (
                        `${subscription.referDetails.firstName || ""} ${subscription.referDetails.lastName || ""}`.trim() ||
                        subscription.referDetails.mobileNo || "N/A"
                      ) : subscription?.userId?.referBy ? (
                        subscription.userId.referBy
                      ) : (
                        "N/A"
                      )}
                    </td>

                    <td>
                      <ul className="seller-info">
                        <li>
                          <span className="label">Seller Name:</span>
                          {subscription?.sellerDetails?.firstName || "N/A"} {subscription?.sellerDetails?.lastName || ""}
                        </li>
                        <li>
                          <span className="label">Mobile Number:</span>
                          {subscription?.sellerDetails?.mobileNo || "N/A"}
                        </li>
                        <li>
                          <span className="label">Earning Type:</span>
                          {subscription?.sellerDetails?.earningType || "N/A"}
                        </li>
                        {/* User Name */}
                        {/* <li>
                        <span className="label">User Name:</span>
                        {user?.sellerDetails?.firstName || "N/A"} {user?.sellerDetails?.lastName || ""}
                      </li> */}
                        <li>
                          <span className="label">KYC Status:</span>
                          <span
                            className={`kyc-status ${subscription?.sellerDetails?.isKycVerified ? "verified" : "not-verified"
                              }`}
                          >
                            {subscription?.sellerDetails?.isKycVerified ? "Verified" : "Not Verified"}
                          </span>
                        </li>
                      </ul>
                    </td>
                    <td>{subscription?.paymentMode || "-"}</td>
                    <td>{subscription?.membershipId?.price || "N/A"}</td>
                    <td>
                      {/* <div className="custom-dropdown">
                        <select
                          className={`status-select ${normalizeStatus(subscription?.payment_status).toLowerCase()}`}
                          value={normalizeStatus(subscription?.payment_status)}
                          onChange={(e) =>
                            handleSubscriptionStatusChange(e.target.value, subscription)
                          }
                        >
                          <option value="Pending">⏳ Pending</option>
                          <option value="Success">✅ Success</option>
                          <option value="Cancelled">❌ Cancelled</option>
                          <option value="Failed">⚠️ Failed</option>
                        </select>
                      </div> */}
                      <td>
                        <span
                          className={`status-badge ${normalizeStatus(subscription?.payment_status).toLowerCase()}`}
                        >
                          {normalizeStatus(subscription?.payment_status)}
                        </span>
                      </td>
                    </td>
                    <td>{subscription?.status || "N/A"}</td>


                    {/* <td className="view-cities-button" onClick={() => handleViewDetails(subscription)}>
                      <FaRegEye className="custom-icon" />
                      <Tooltip id="view-cities-tooltip" />
                    </td> */}

                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil((filteredUsers?.length || 0) / usersPerPage)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            initialPage={currentPage - 1}
            disableInitialCallback={true}
            pageLinkClassName={'page-link'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
            pageClassName={'page-item'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            disabledClassName={'disabled'}
          />
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Subscription Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewUsersubcription
          user={selectedUser}
          closeModal={closeModal}
        />
      </Modal>


      <style jsx>{`
  .summary-card {
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
  }

  .summary-box {
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .summary-label {
    font-size: 13px;
    color: #6b7280;
    font-weight: 500;
    margin-bottom: 6px;
  }

  .summary-value {
    font-size: 24px;
    font-weight: 700;
    color: #111827;
  }

  .status-badge {
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.status-badge.pending {
  background: #fff3cd;
  color: #856404;
}

.status-badge.success {
  background: #d4edda;
  color: #155724;
}

.status-badge.cancelled {
  background: #f8d7da;
  color: #721c24;
}

.status-badge.failed {
  background: #ffe5b4;
  color: #8a6d3b;
}
`}</style>

    </div>
  );
}

export default SubcriptionUserManager;